import React, {Component} from 'react'

import styled from '@emotion/styled'
import StyleVariales from '../../../../styles/styles'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

// STYLE ##########################################################

const sv = StyleVariales;

const padding = 8;
const lineHeight = 22;

const Wrapper = styled('div')`
  position: relative;
  z-index: 1500;
`;

const ModalWrapper = styled('div')`
  position: absolute;
  z-index: 1500;
  top: ${props => props.top};
  left: ${props => props.left};
  height: ${props => props.height};
  width: ${props => props.width};
`;

const ModalShade = styled('div')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: rgba(0,0,0,.8);
`;

const Tip = styled('div')`
  position: absolute;
  left: ${props => props.left}px;
  top: ${props => props.top}px;
  box-shadow: 0 0 12px rgba(0,0,0,.75);
  border-radius: 4px;
  transition: bottom .1s ease-out, opacity .2s ease-out;
  background: #454545;
  color: rgba(255,255,255,.7);
  z-index: 500;
  font-size: 14px;
  line-height: ${props => props.lineHeight}px;
  letter-spacing: .5px;
  font-weight: 300;
  width: ${props => props.width}px;
  margin-left: ${props => props.marginLeft}px;
  padding: ${props => props.padding}px;
  opacity: 1;
  text-transform: none;
  cursor: text;
  span {
    font-weight: 700;
    color: ${sv.colors.light};
    padding: 2px;
  }
`;

const CloseButton = styled('div')`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0px;
  height: 50px;
  width: 50px;
  color: ${sv.colors.light};
  margin: 18px;
`;

// COMPONENT ##########################################################

class ToolTip extends Component {

  constructor(props) {
    super(props);

    this.state = {
      width: 250,
      tipMarginLeft: 0,
      tipLeft: undefined,
      tipTop: undefined,
      modalLeft: undefined,
      modalTop: undefined,
      modalHeight: undefined,
      modalWidth: undefined
    };
  }

  componentDidMount () {
    document.addEventListener("keydown", this.onKeyDown, false);

    // re-renders the component so parent ref is loaded and tip adjustment is performed on update
    this.setState(this.state);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleClose, false);
  }

  componentDidUpdate(prevProps, prevState) {
    this.updateTipAdjustments();
  }

  static checkVerticalOverlap(player, tip) {
    return player && tip && tip.bottom > player.bottom;
  }

  updateTipAdjustments() {
    if (this.tip && this.props.getGistPlayerRect) {
      let playerRect = this.props.getGistPlayerRect();
      let tipRect = this.tip.getBoundingClientRect();

      if (playerRect && !this.updateModal()) {
        if (ToolTip.checkVerticalOverlap(playerRect, tipRect)) {
          const newWidth = this.state.width + 40;
          if (newWidth < playerRect.width) {
            this.setState({width: newWidth});
          }
        } else {
          this.updateTipHorizontalAdjustment(playerRect, tipRect);
        }
      }
    }
  }

  /**
   * Updates state for modal window
   *
   * @returns {boolean} True if the modal window has been appropriately updated as far as possible
   */
  updateModal() {
    const {modal} = this.props;
    let modalUpdated = false;

    if (modal && this.tip) {

      let {modalLeft} = this.state;
      const gistItemRect = this.props.getGistItemRect();
      const playerRect = this.props.getGistPlayerRect();

      if (modalLeft === undefined && gistItemRect && playerRect) {

        let newModalLeft = playerRect.left - gistItemRect.left + (this.props.marginLeft ? this.props.marginLeft : 0);
        let newModalTop = playerRect.top - gistItemRect.top + (this.props.marginTop ? this.props.marginTop : 0);
        let newModalHeight = playerRect.height;
        let newModalWidth = playerRect.width;

        this.setState({
          modalLeft: newModalLeft,
          modalTop: newModalTop,
          modalHeight: newModalHeight,
          modalWidth: newModalWidth,
          tipTop: gistItemRect.height - newModalTop + this.props.marginTop,
          tipLeft: gistItemRect.left + this.props.marginLeft
        });

        modalUpdated = true;
      }

    }

    return modalUpdated;
  }

  updateTipHorizontalAdjustment(player, tip) {
    if (player && tip && tip.right > player.right) {
      //the +5 added to the container adds just a bit of clearance to make it look cleaner
      let newMarginLeft = this.state.tipMarginLeft - (tip.right-player.right+5);
      this.setState({tipMarginLeft: newMarginLeft});
    }
  }

  onKeyDown = (e) => {
    if (e.keyCode === 27) {   // escapekey
      this.handleClose();
    }
  };

  handleClose = () => {
    this.props.onClickClose();
  };

  render() {
    const {modal} = this.props;

    const content =
          <Tip
              ref={ (elm) => this.tip = elm}
              style={this.props.style}
              width={this.state.width}
              marginLeft={this.state.tipMarginLeft}
              left={this.state.tipLeft}
              top={this.state.tipTop}
              lineHeight={lineHeight}
              padding={padding}
          >
            {this.props.children}
          </Tip>;

    let tip;

    if (modal) {
      const {modalLeft, modalTop, modalHeight, modalWidth} = this.state;
      tip = <ModalWrapper
          left={modalLeft + "px"}
          top={modalTop + "px"}
          height={modalHeight + "px"}
          width={modalWidth + "px"}
          onClick={this.handleClose}
      >
        <ModalShade>
          <CloseButton><FontAwesomeIcon icon="times" size="lg"/></CloseButton>
        </ModalShade>
        {content}
      </ModalWrapper>;
    } else {
      tip = <Wrapper>{content}</Wrapper>;
    }

    return tip;
  }

}

export default ToolTip;
